import { z } from 'zod';

export const TicketResponseSchema = z.object({ ticket: z.string() });

/**
 * Typed realtime event envelope (ARCHITECTURE_PLAN §5.6). Thin notifications
 * only — never authoritative data. Clients re-fetch via React Query
 * invalidation, so a lost event degrades to the next poll/refetch.
 *
 * Envelope: `{ event, entityId, at }` for every event.
 */

export const REALTIME_EVENTS = [
  'message.created',
  'message.status_changed',
  'conversation.updated',
  'lead.updated',
  'call.missed',
  'appointment.created',
  'job.failed',
  'usage.threshold',
] as const;

export const RealtimeEventTypeSchema = z.enum(REALTIME_EVENTS);
export type RealtimeEventType = z.infer<typeof RealtimeEventTypeSchema>;

export const RealtimeEventSchema = z.object({
  event: RealtimeEventTypeSchema,
  entityId: z.string().min(1),
  at: z.number().int(),
});

export type RealtimeEvent = z.infer<typeof RealtimeEventSchema>;

export function buildRealtimeEvent(
  event: RealtimeEventType,
  entityId: string,
  at: number = Date.now()
): RealtimeEvent {
  return { event, entityId, at };
}
